import React, { Component } from 'react';
import { Query } from 'react-apollo';

import '../style/ActivityLog.scss';
import queries from '../queries';
import { timeAgo } from '../toast';
import { t, dateLocale } from '../i18n';

// Libellés lisibles pour les actions techniques du journal : [clé de traduction, type de pastille].
const KINDS = {
  createProject: 'create', updateProject: 'edit', archiveProject: 'delete', restoreProject: 'create',
  duplicateProject: 'create', deleteProject: 'delete', createPage: 'create', updatePage: 'edit',
  duplicatePage: 'create', copyPageToProject: 'create', deletePage: 'delete', createCell: 'create',
  duplicateCell: 'create', deleteCell: 'delete', updateCells: 'edit', createFont: 'create',
  createProduct: 'create', updateProduct: 'edit', deleteProduct: 'delete', updateDevice: 'edit',
  createShareLink: 'create', updateShareLink: 'edit', deleteShareLink: 'delete',
};

const labelFor = (operation) => {
  if (KINDS[operation]) return [t(`ui.act.${operation}`), KINDS[operation]];
  const m = operation.match(/^update(.+)Cell$/);
  if (m) return [t('ui.act.cellUpdate', { type: m[1] }), 'edit'];
  if (/^create/.test(operation)) return [t('ui.act.createX', { what: operation.replace(/^create/, '') }), 'create'];
  if (/^delete/.test(operation)) return [t('ui.act.deleteX', { what: operation.replace(/^delete/, '') }), 'delete'];
  if (/^update/.test(operation)) return [t('ui.act.updateX', { what: operation.replace(/^update/, '') }), 'edit'];
  return [operation, 'edit'];
};

// Journal d'activité (administrateurs) : qui a fait quoi, quand.
class ActivityLog extends Component {

  state = { user: '' };

  render() {
    const { user } = this.state;
    return (
      <div className='tsk-page-board'>
        <header className='tsk-page-hero'>
          <h1 className='tsk-page-hero__title'>{t('ui.activity.title')}</h1>
          <p className='tsk-page-hero__subtitle'>{t('ui.act.sub')}</p>
        </header>
        <Query query={queries.activity.list} variables={{ limit: 300 }} fetchPolicy='network-only' pollInterval={30000}>
          {({ data, loading, error }) => {
            if (error) return <p>{t('ui.act.error')}</p>;
            if (!data || !data.activityLog) return loading ? <p>{t('ui.common.loading')}</p> : null;
            const entries = data.activityLog;
            const users = [...new Set(entries.map((e) => e.user_email).filter(Boolean))];
            const filtered = entries.filter((e) => !user || e.user_email === user);
            return (
              <>
                <div className='tsk-displays-toolbar'>
                  <select value={user} onChange={(e) => this.setState({ user: e.target.value })} aria-label={t('ui.act.filter')}>
                    <option value=''>{t('ui.act.all_users')}</option>
                    {users.map((u) => <option key={u} value={u}>{u}</option>)}
                  </select>
                </div>
                {filtered.length === 0 ? (
                  <div className='tsk-empty'>
                    <h3>{t('ui.act.empty_title')}</h3>
                    <p>{t('ui.act.empty_text')}</p>
                  </div>
                ) : (
                  <ul className='tsk-activity'>
                    {filtered.map((entry) => {
                      const [label, kind] = labelFor(entry.operation);
                      return (
                        <li key={entry.id} className={`tsk-activity__item tsk-activity__item--${kind}`}>
                          <span className='tsk-activity__dot' />
                          <span className='tsk-activity__label'>{label}</span>
                          <span className='tsk-activity__user'>{entry.user_email || t('ui.act.unknown_user')}</span>
                          <time className='tsk-activity__time' title={new Date(entry.at).toLocaleString(dateLocale)}>
                            {timeAgo(entry.at)}
                          </time>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </>
            );
          }}
        </Query>
      </div>
    );
  }
}

export default ActivityLog;
